import React, {useState} from 'react';
import {Avatar, Button, Form, Input, message, Skeleton} from 'antd';
import {useMutation, useQuery, useQueryClient} from "react-query";
import {GetProfile, VerificationCode, UpdateProfile} from "../../../api/profile";
import parsePhoneNumber from "libphonenumber-js";


export const Profile = (props) => {
    const {data} = useQuery('profile', GetProfile);
    const [formEmail, setFormEmail] = useState(false);
    const [formPhone, setFormPhone] = useState(false);

    const profile = data && data.profile ? data.profile : false;

    const buildUserName = () => {
        if (!profile) return '';
        let params = [];
        if (profile.first_name.length > 0) {
            params.push(profile.first_name[0])
        }
        if (profile.last_name.length > 0) {
            params.push(profile.last_name[0])
        }
        return params.join('');
    }


    return (
        <div className={`appc profile`}>
            <h1>Редактирование профиля</h1>
            {(!data || !data.profile) && <Skeleton rows={4}/>}
            {data && data.profile && (
                <div className={`profile--block`}>
                    <div className="profile--block__header">
                        <Avatar
                            size={80}
                            shape={`circle`}
                            style={{backgroundColor: '#0d4cd3', color: '#FFF'}}
                        >
                            {buildUserName()}
                        </Avatar>
                        <div className="profile--block__info">
                            {profile ? <span
                                className={`profile__name`}>{profile.first_name} {profile.last_name}</span> : null}
                            {profile ? <span className={`profile__role`}>{profile.type}</span> : null}
                        </div>
                    </div>
                    <div className={`profile--block__body`}>
                        {formEmail === false && (
                            <div className="profile__email">
                                <span>{profile.email}</span>
                                <Button
                                    type={"link"}
                                    onClick={() => setFormEmail(true)}
                                >
                                    Изменить
                                </Button>
                            </div>
                        )}
                        {formEmail === true && (
                            <div className="profile__email form">
                                <FormEmail
                                    email={profile.email}
                                    onCancel={() => setFormEmail(false)}
                                />
                            </div>
                        )}


                        {formPhone === false && (<div className="profile__phone">
                            <span>{profile.phone}</span>
                            <Button type={"link"}  onClick={() => setFormPhone(true)}>Изменить</Button>
                        </div>)}

                        {formPhone === true && (
                            <div className="profile__phone form">
                                <FormPhone
                                    phone={profile.phone}
                                    onCancel={() => setFormPhone(false)}
                                />
                            </div>
                        )}

                        <div className={`reset__password`}>
                            <a href={"#"} onClick={() => message.info(`функция в разработке`)}>Изменить пароль</a>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}


const FormEmail = (props) => {
    const queryClient = useQueryClient();
    const [isValidEmail, setValidEmail] = useState(false);
    const [codeSended, setCodeSended] = useState(false);
    const [email, setEmail] = useState('');

    const VerificationMutation = useMutation(
        (data) => VerificationCode(data),
        {
            onSuccess: (data, vars) => {
                setCodeSended(true);
                message.success(`На ваш email-адрес отправлен проверочный код`);
            },
            onError: (e) => {
                console.error(`[VerificationMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    )

    const UpdateProfileMutation = useMutation(
        (data) => UpdateProfile(data),
        {
            onSuccess: (data, vars) => {
                queryClient.invalidateQueries('profile');
                props.onCancel();
                message.success(`Ваш профиль успешно обновлен`);
            },
            onError: (e) => {
                console.error(`[UpdateProfileMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    )

    const onFieldsChange = (_, allFields) => {
        let email = allFields.filter(i => i.name.indexOf('email') + 1 > 0);
        setValidEmail(email && email.length > 0 && email[0].value && email[0].errors.length === 0);
    }

    const onFinish = (props) => {
        setEmail(props.email);
        VerificationMutation.mutate({
            type: 'email',
            value: props.email,
        })
    }

    const onFinishCode = (props) => {
        UpdateProfileMutation.mutate({
            type: "email",
            value: email,
            code: props.code || "",
        })
    }

    if (codeSended === false) {
        return (
            <Form
                name={`email_update`}
                layout={"vertical"}
                onFinish={onFinish}
                onFieldsChange={onFieldsChange}
                autoComplete="off"
            >
                <h2>Редактирование электронной почты {props.email}</h2>
                <Form.Item
                    label={`Эл. почта`}
                    name="email"
                    extra={`На этот адрес будет отправлено письмо с кодом подтверждения`}
                    rules={[
                        {required: true, message: 'Укажите ваш почтовый адрес'},
                        {type: 'email', message: 'Укажите корректный почтовый адрес'},
                    ]}
                >
                    <Input
                        type={`email`}
                    />
                </Form.Item>
                <div className={`profile__form--actions`}>
                    <Button loading={VerificationMutation.isLoading} disabled={!isValidEmail} type={`primary`} htmlType={`submit`}>Отправить код</Button>
                    <Button loading={VerificationMutation.isLoading} onClick={props.onCancel}>Отменить</Button>
                </div>
            </Form>
        );
    } else {
        return (
            <Form
                name={`email_update`}
                layout={"vertical"}
                onFinish={onFinishCode}
                autoComplete="off"
            >
                <h2>Редактирование электронной почты {props.email}</h2>
                <Form.Item
                    label={`Введите код из письма`}
                    name="code"

                    rules={[
                        {required: true, message: 'Укажите код'},

                    ]}
                >
                    <Input/>
                </Form.Item>
                <div className={`profile__form--actions`}>
                    <Button type={`primary`} htmlType={`submit`} loading={UpdateProfileMutation.isLoading}>Сохранить</Button>
                </div>
            </Form>
        );
    }


}

const FormPhone = (props) => {
    const queryClient = useQueryClient();
    const [isValidPhone, setValidPhone] = useState(false);
    const [codeSended, setCodeSended] = useState(false);
    const [phone, setPhone] = useState('');

    const VerificationMutation = useMutation(
        (data) => VerificationCode(data),
        {
            onSuccess: (data, vars) => {
                setCodeSended(true);
                message.success(`На ваш телефон в скором времени поступит звонок`);
            },
            onError: (e) => {
                console.error(`[VerificationMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    )

    const UpdateProfileMutation = useMutation(
        (data) => UpdateProfile(data),
        {
            onSuccess: (data, vars) => {
                queryClient.invalidateQueries('profile');
                props.onCancel();
                message.success(`Ваш профиль успешно обновлен`);
            },
            onError: (e) => {
                console.error(`[UpdateProfileMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    )


    const onFinish = (props) => {
        setPhone(props.phone);
        VerificationMutation.mutate({
            type: 'phone',
            value: props.phone,
        })
    }

    const onFinishCode = (props) => {
        UpdateProfileMutation.mutate({
            type: "phone",
            value: phone,
            code: props.code || "",
        })
    }

    if (codeSended === false) {
        return (
            <Form
                name={`phone_update`}
                layout={"vertical"}
                onFinish={onFinish}
                autoComplete="off"
            >
                <Form.Item
                    label={`Телефон`}
                    name={`phone`}
                    rules={[
                        {required: true, message: `Укажите номер телефона`},
                        {
                            validator: async (_, phone = '') => {
                                // const { short, phone, code } = names;
                                const phoneNumber = parsePhoneNumber(phone);
                                if (!phoneNumber || !phoneNumber.isValid()) {
                                    setValidPhone(false);
                                    return Promise.reject(new Error('Введен не корректный номер телефона'));
                                } else {
                                    setValidPhone(phone !== '');
                                }
                            }
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>
                <div className={`profile__form--actions`}>
                    <Button loading={VerificationMutation.isLoading} disabled={!isValidPhone} type={`primary`} htmlType={`submit`}>Отправить код</Button>
                    <Button loading={VerificationMutation.isLoading} onClick={props.onCancel}>Отменить</Button>
                </div>
            </Form>
        );
    } else {
        return (
            <Form
                name={`phone_update`}
                layout={"vertical"}
                onFinish={onFinishCode}
                autoComplete="off"
            >
                <h2>Редактирование электронной почты {props.email}</h2>
                <Form.Item
                    label={`Код из звонка`}
                    name="code"
                    extra={`На ваш телефон поступит звонок, укажите последние 4-е цифры из звонящего номера`}
                    rules={[
                        {required: true, message: 'Укажите код'},

                    ]}
                >
                    <Input/>
                </Form.Item>
                <div className={`profile__form--actions`}>
                    <Button type={`primary`} htmlType={`submit`} loading={UpdateProfileMutation.isLoading}>Сохранить</Button>
                </div>
            </Form>
        );
    }


}

export default Profile;